import React, {Component} from 'react';
import {Button, cls} from '../../../packages/components';
import Translator from '../../../requests/apa/Translator';
import Assets from '../../../requests/apa/Asset';
import Utils from '../../../utils/Utils';
import './ModalChangeAAFToClaroTV.scss';
import {
  KEY_TITULO,
  MAX_CHARS_TITULO,
  KEY_DESCRIPCION,
  MAX_CHARS_PARRAFO,
  KEY_TEXTO_LEGAL,
  MAX_CHARS_DISCLAIMER,
  KEY_BOTON_DESCARGAR,
  MAX_CHARS_BOTON_DESCARGA,
  KEY_BOTON_MAS_TARDE,
  MAX_CHARS_BOTON_MAS_TARDE,
  KEY_BACKGROUND,
  KEY_LOGO
} from './constants';
import ModalWrapper, {withOnClose} from "../ModalWrapper";
import {closeModal, getConfig, handleOpenAppStore} from "./utils";
import {removeDynamicFocus} from "../../Focus/utils";
import {GA4} from '../../../utils/trackers/GA4';
import {
  MIGRATION_TYPE_INFORMATIVE,
  MIGRATION_TYPE_MANDATORY,
  MODULO_NAME_MIGRATION,
  PAGE_PATH_MIGRATION,
  PAGE_TITLE_MIGRATION,
  INTERACTION_TYPE_DOWNLOAD_CLARO_TV,
  INTERACTION_TYPE_LATER,
  DOES_NOT_APPLY,
} from '../../../utils/trackers/GA4Constants';

const getMigrationPayload = () => {
  const {mandatory} = getConfig();

  return {
    migration_type: mandatory ? MIGRATION_TYPE_MANDATORY : MIGRATION_TYPE_INFORMATIVE,
    page_path: PAGE_PATH_MIGRATION,
    page_title: PAGE_TITLE_MIGRATION,
    previous_path: DOES_NOT_APPLY,
    modulo_name: MODULO_NAME_MIGRATION,
  };
};

class ModalChangeAAFToClaroTV extends Component {
  componentDidMount() {
    Utils.setInitialFocusChangeTime('.change-aaf-to-claro-tv_button-primary', 1000);
    removeDynamicFocus();

    const migrationPayload = getMigrationPayload();
    new GA4().sendMigrationImpressionEvent(migrationPayload);
  }

  render() {
    const {showSecondaryButton = true, onDownload, handleClose} = this.props;

    const migrationPayload = getMigrationPayload();

    const handleDownloadClick = () => {
      new GA4().sendMigrationClickEvent(migrationPayload, INTERACTION_TYPE_DOWNLOAD_CLARO_TV);
      handleOpenAppStore();
    };

    const handleLaterClick = () => {
      new GA4().sendMigrationClickEvent(migrationPayload, INTERACTION_TYPE_LATER);
      closeModal();
    };

    const backgroundImage = Assets.get(KEY_BACKGROUND);
    const logoImage = Assets.get(KEY_LOGO);

    const title = Utils.truncateToLength(
      KEY_TITULO,
      Translator.get(KEY_TITULO),
      MAX_CHARS_TITULO
    );
    const description = Utils.truncateToLength(
      KEY_DESCRIPCION,
      Translator.get(KEY_DESCRIPCION),
      MAX_CHARS_PARRAFO
    );
    const primaryButtonLabel = Utils.truncateToLength(
      KEY_BOTON_DESCARGAR,
      Translator.get(KEY_BOTON_DESCARGAR),
      MAX_CHARS_BOTON_DESCARGA
    );
    const secondaryButtonLabel = Utils.truncateToLength(
      KEY_BOTON_MAS_TARDE,
      Translator.get(KEY_BOTON_MAS_TARDE),
      MAX_CHARS_BOTON_MAS_TARDE
    );
    const legalText = Utils.truncateToLength(
      KEY_TEXTO_LEGAL,
      Translator.get(KEY_TEXTO_LEGAL),
      MAX_CHARS_DISCLAIMER
    );

    return (
      <ModalWrapper>
        <div className="change-aaf-to-claro-tv"
             style={{
               backgroundImage: `url(${backgroundImage})`,
               backgroundSize: 'cover',
               backgroundPosition: 'center'
             }}
        >
          <div className="change-aaf-to-claro-tv_content">
            <h1 className="change-aaf-to-claro-tv_title">{title}</h1>
            <p className="change-aaf-to-claro-tv_description">{description}</p>
            <div className="change-aaf-to-claro-tv_icon">
              {logoImage && logoImage !== KEY_LOGO
                ? <img className="change-aaf-to-claro-tv_icon-image"
                       src={logoImage} alt={``}/>
                : <span
                  className="change-aaf-to-claro-tv_icon-placeholder">{KEY_LOGO}</span>
              }
            </div>
            <Button
              type="button"
              variant="primary"
              className={cls('focusable', 'btn', 'change-aaf-to-claro-tv_button-primary')}
              onClick={handleDownloadClick}
            >
              {primaryButtonLabel}
            </Button>

            <Button
              type="button"
              variant="default"
              className={cls('btn', 'change-aaf-to-claro-tv_button-secondary', {
                focusable: showSecondaryButton,
                'change-aaf-to-claro-tv_button-secondary--hidden': !showSecondaryButton
              })}
              onClick={showSecondaryButton ? handleLaterClick : undefined}
            >
              {secondaryButtonLabel}
            </Button>

            <p className="change-aaf-to-claro-tv_legal">{legalText}</p>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default withOnClose(ModalChangeAAFToClaroTV);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalChangeAAFToClaroTV/ModalChangeAAFToClaroTV.jsx